import { render, staticRenderFns } from "./document_printer.vue?vue&type=template&id=1512abe1&scoped=true&"
import script from "./document_printer.vue?vue&type=script&lang=js&"
export * from "./document_printer.vue?vue&type=script&lang=js&"
import style0 from "./document_printer.vue?vue&type=style&index=0&id=1512abe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1512abe1",
  null
  
)

export default component.exports